module.exports = __webpack_public_path__ + "static/media/logo_generalitat_blanc.794b08bb.svg";